import { eventChannel } from 'redux-saga'
import { all, call, put, select, take, takeLatest } from 'redux-saga/effects'
import { IS_PRODUCTION } from 'utils/helperConfig'

import * as alertActions from 'redux/alert/alert-actions'
// eslint-disable-next-line no-unused-vars
import * as allAssetsActions from 'redux/allAssets/allAssets-actions'
import * as settingsActions from 'redux/settings/settings-actions'
import * as signalRActions from 'redux/signalR/signalR-actions'
import * as userActions from 'redux/user/user-actions'
// eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
import UserActionTypes from 'redux/user/user-types'
// eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars

import signalRConnection from './signalR-connection'

function* signInSuccess() {
    signalRConnection
        .start()
        .then(() => {
            if (!IS_PRODUCTION) {
                // eslint-disable-next-line no-console
                console.log('WebSocked connection started')
            }
        })
        .catch(err => {
            if (!IS_PRODUCTION) {
                // eslint-disable-next-line no-console
                console.log(`Error while starting WebSocked connection: ${err}`)
            }
        })

    const getEventChannel = connection =>
        eventChannel(emit => {
            const handler = data => {
                emit(data)
            }

            connection.on('notification', handler)

            return () => {
                connection.off()
            }
        })

    const channel = yield call(getEventChannel, signalRConnection)

    while (true) {
        const { type, payload } = yield take(channel)

        if (
            (type === 'TransferStatusChanged' || type === 'TransferCreated') &&
            (payload?.status === 'Finished' ||
                payload?.status === 'Canceled' ||
                payload?.status === 'Processing' ||
                payload?.status === 'WaitingForApproval')
        ) {
            yield put(signalRActions.startFetchTransactions())
            yield put(allAssetsActions.startFetchAllAssets())
        }

        if (type === 'AssetStatusChanged') {
            yield put(allAssetsActions.startFetchAllAssets())
        }

        if (type === 'IdentityProfileKycStatusChanged') {
            const notMatchQuestionnairePath = window?.location?.pathname !== '/questionnaire'

            if (notMatchQuestionnairePath) {
                yield put(userActions.startFetchIdentity())
                yield put(alertActions.fetchNotificationAlert())
            }
        }

        if (type === 'IdentityProfileStatusChanged') {
            if (payload?.newStatus === 'Deactivated') {
                yield put(userActions.changeUserStatus({ accountDeactivated: true }))
            } else {
                const notMatchQuestionnairePath = window?.location?.pathname !== '/questionnaire'

                if (notMatchQuestionnairePath) {
                    yield put(userActions.startFetchIdentity())
                    yield put(alertActions.fetchNotificationAlert())
                }
            }
        }

        if (type === 'NewConversationMessage') {
            yield put(settingsActions.fetchSupportUnreadConversationsCount())
        }

        if (type === 'NewDocumentRequest' || type === 'DocumentStatusChanged') {
            yield put(settingsActions.fetchDocumentRequests())
            yield put(alertActions.fetchNotificationAlert())
        }

        if (type === 'DocumentExpirationChanged') {
            yield put(alertActions.fetchNotificationAlert())
            yield put(userActions.startFetchIdentity())
        }

        if (payload?.source === 'FeeBasket' && payload?.status === 'Pending') {
            yield put(signalRActions.startFetchTransactions())
            yield put(alertActions.fetchNotificationAlert())
        }

        if (type === 'CompanyRegistrationFeePaid') {
            yield put(userActions.startGetCompaniesRegistrationFee())
        }

        if (type === 'PersonalEmailConfirmationChanged') {
            yield put(userActions.startCheckUserEmailStatus())
        }
    }
}

export function* onSignSuccess() {
    yield takeLatest(UserActionTypes.SIGN_IN_SUCCESS, signInSuccess)
}

export function* signalRSagas() {
    yield all([call(onSignSuccess)])
}
